import {
  ChefHat,
  Table,
  IceCream,
  DollarSign,
  ShoppingCart,
  LayoutDashboard,
  BarChart,
  Tag,
  Package,
  FileText,
  Shuffle,
  User,
  Settings,
  LogOut,
  MessageCircle,
  TrendingUp,
  TrendingDown,
  Users,
  ShoppingBag,
  UserCog,
  Star,
  ClipboardList,
} from 'lucide-react';
import React from 'react';
import type { UserRole } from '../hooks/useRole';

export interface MenuItem {
  label: string;
  path: string;
  icon?: React.ReactElement;
  /** Legacy role filter (still used as fallback) */
  roles?: UserRole[];
  /** Permission module key – if set, item is hidden unless user can view this module */
  module?: string;
  /** Group / category for grouping in the sidebar */
  group?: 'analytics' | 'operations' | 'finance' | 'logistics' | 'management' | 'other';
}

export const menuItems: MenuItem[] = [
  // Dashboard e Informes
  { label: 'Dashboard',    path: '/dashboard',          icon: <BarChart size={20} />,           module: 'dashboard', group: 'analytics' },
  { label: 'Reportes',     path: '/reports',             icon: <TrendingUp size={20} />,         module: 'reports', group: 'analytics' },
  { label: 'KPIs',         path: '/kpi',                 icon: <LayoutDashboard size={20} />,    module: 'kpi', group: 'analytics' },

  // Operaciones
  { label: 'POS',          path: '/pos',                 icon: <ShoppingCart size={20} />,       module: 'pos', group: 'operations' },
  { label: 'Cocina',       path: '/kitchen',             icon: <ChefHat size={20} />,            module: 'kitchen', group: 'operations' },
  { label: 'Mesas',        path: '/tables',              icon: <Table size={20} />,              module: 'tables', group: 'operations' },
  { label: 'Plano',        path: '/tables/floor',          icon: <LayoutDashboard size={20} />,    module: 'tables', group: 'operations' },

  // Ventas y Finanzas
  { label: 'Caja',         path: '/cash',                icon: <DollarSign size={20} />,         module: 'cash', group: 'finance' },
  { label: 'Movimientos',  path: '/cash/movements',      icon: <Shuffle size={20} />,            module: 'cash', group: 'finance' },
  { label: 'Historial',    path: '/orders/history',      icon: <ShoppingBag size={20} />,        module: 'order_history', group: 'finance' },
  { label: 'Clientes',     path: '/customers',            icon: <Star size={20} />,               module: 'customers', group: 'finance' },

  // Logística y Stock
  { label: 'Inventario',   path: '/inventory',           icon: <Package size={20} />,            module: 'inventory', group: 'logistics' },
  { label: 'Compras',      path: '/purchases',            icon: <ShoppingCart size={20} />,       module: 'purchases', group: 'logistics' },
  { label: 'Gastos',       path: '/purchases/expenses',   icon: <TrendingDown size={20} />,       module: 'purchases', group: 'logistics' },
  { label: 'Nómina',       path: '/purchases/payroll',    icon: <Users size={20} />,              module: 'purchases', group: 'logistics' },
  { label: 'Servicios',    path: '/purchases/utilities',  icon: <TrendingDown size={20} />,       module: 'purchases', group: 'logistics' },
  { label: 'Proveedores',  path: '/purchases/suppliers',  icon: <Users size={20} />,              module: 'purchases', group: 'logistics' },
  { label: 'Mercado',      path: '/shopping',            icon: <ClipboardList size={20} />,      module: 'shopping', group: 'logistics' },

  // Catálogo y Gestión
  { label: 'Categorias',   path: '/categories',          icon: <Tag size={20} />,                module: 'categories', group: 'management' },
  { label: 'Productos',    path: '/products',            icon: <Package size={20} />,            module: 'products', group: 'management' },
  { label: 'Sabores',      path: '/flavors',             icon: <IceCream size={20} />,           module: 'flavors', group: 'management' },
  { label: 'WhatsApp Bot', path: '/whatsapp',            icon: <MessageCircle size={20} />,      module: 'whatsapp', group: 'management' },
  { label: 'Usuarios',     path: '/users',               icon: <UserCog size={20} />,            module: 'users', group: 'management' },
  { label: 'Auditoría',    path: '/audit-logs',          icon: <ClipboardList size={20} />,      module: 'users', group: 'management' },
  { label: 'Perfiles',     path: '/profiles',            icon: <UserCog size={20} />,            module: 'settings', group: 'management' },
  { label: 'Configuración',path: '/settings',            icon: <Settings size={20} />,           module: 'settings', group: 'management' },
  { label: 'Swagger',      path: '/swagger',             icon: <FileText size={20} />,           roles: ['admin'], group: 'management' },

  // Otros / Sin grupo (fijos al final)
  { label: 'Profile',      path: '/profile',             icon: <User size={20} />, group: 'other' },
  { label: 'Logout',       path: '/logout',              icon: <LogOut size={20} />, group: 'other' },
];
